import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { BRAND, NAV } from "@/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--ink)] text-white">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo testId="footer-logo-link" className="text-white" />
          <p className="mt-6 text-[15px] text-neutral-300 max-w-xs leading-relaxed">Cleaner water. Healthier homes. Proudly serving San Diego County.</p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow !text-neutral-300 mb-5">Explore</p>
          <ul className="space-y-3">
            {NAV.map((l) => (
              <li key={l.to}><Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-[15px] text-neutral-300 hover:text-white transition-colors">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow !text-neutral-300 mb-5">Contact</p>
          <ul className="space-y-3 text-[15px] text-neutral-300">
            <li><a data-testid="footer-phone" href={BRAND.phoneHref} className="hover:text-white">{BRAND.phone}</a></li>
            <li><a data-testid="footer-email" href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a></li>
            <li data-testid="footer-hours">{BRAND.hours}</li>
            <li data-testid="footer-area">San Diego County, CA</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/15">
        <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-12 py-6 text-[13px] text-neutral-400">© {new Date().getFullYear()} {BRAND.name} All rights reserved.</div>
      </div>
    </footer>
  );
}
